import React from "react";
import "../moodle.css";
import { Link } from "react-router-dom";
import { Button,  Header, Label } from "semantic-ui-react";
import { ErrorMessage, Form, Formik } from "formik";
import { observer } from "mobx-react-lite";
import Autenticarse from "./Autenticar";
import Banner from "../Banner";
import ScrollToTop from "../ScrollToTop";




function LoginMod() {
    return (

     <div>
  
        <Banner
            banner='images/teclado.jpg'
        />    
         <Autenticarse llaves={"123-Inap-$$$"}/>    
         <ScrollToTop  />    
        
        
        </div>
    );
  }
  
  export default LoginMod;
    